module.exports = __webpack_public_path__ + "static/media/videoNull.90ae693c.png";